/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { EdiMessageTypeWithConfigFragmentDoc } from './EdiMessageTypeWithConfigFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IEdiMessageTypesQueryVariables = Types.Exact<{
  connectionConfigType?: Types.Maybe<Types.Scalars['String']>
  connectionConfigIds?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
}>

export type IEdiMessageTypesQuery = { __typename?: 'Query' } & {
  ediMessageTypes: { __typename?: 'EdiMessageConnection' } & {
    nodes?: Types.Maybe<
      Array<
        Types.Maybe<
          { __typename?: 'EdiMessage' } & Pick<
            Types.IEdiMessage,
            | 'id'
            | 'transactionSet'
            | 'transactionSetSubtype'
            | 'legacyParserClass'
            | 'ediMapperConfigurableParserId'
            | 'legacyBuilderClass'
            | 'ediMapperConfigurableBuilderId'
            | 'createdAt'
            | 'updatedAt'
          > & {
              ediMapperConnectionConfig?: Types.Maybe<
                | ({ __typename?: 'InboundConnectionConfig' } & Pick<
                    Types.IInboundConnectionConfig,
                    | 'id'
                    | 'connectionType'
                    | 'createdAt'
                    | 'disabled'
                    | 'environment'
                    | 'partnerApplicationId'
                    | 'partnerApplicationType'
                    | 'tmsName'
                  >)
                | { __typename?: 'OutboundConnectionConfig' }
              >
              configurableParser?: Types.Maybe<
                { __typename?: 'ConfigurableParser' } & Pick<
                  Types.IConfigurableParser,
                  'id' | 'name' | 'createdAt' | 'updatedAt'
                >
              >
              configurableBuilder?: Types.Maybe<
                { __typename?: 'ConfigurableBuilder' } & Pick<
                  Types.IConfigurableBuilder,
                  'id' | 'name' | 'transactionSet' | 'isLive' | 'createdAt' | 'updatedAt'
                >
              >
              ediMapperConfigGroup?: Types.Maybe<
                { __typename?: 'ConfigGroup' } & Pick<
                  Types.IConfigGroup,
                  'id' | 'name' | 'shipperApplicationId'
                >
              >
            }
        >
      >
    >
  }
}

export const EdiMessageTypesDocument = gql`
  query EdiMessageTypes($connectionConfigType: String, $connectionConfigIds: [ID!]) {
    ediMessageTypes(
      connectionConfigType: $connectionConfigType
      connectionConfigIds: $connectionConfigIds
    ) {
      nodes {
        ...EdiMessageTypeWithConfig
        ediMapperConnectionConfig {
          ... on InboundConnectionConfig {
            id
            connectionType
            createdAt
            disabled
            environment
            partnerApplicationId
            partnerApplicationType
            tmsName
          }
        }
      }
    }
  }
  ${EdiMessageTypeWithConfigFragmentDoc}
`

/**
 * __useEdiMessageTypesQuery__
 *
 * To run a query within a React component, call `useEdiMessageTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEdiMessageTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEdiMessageTypesQuery({
 *   variables: {
 *      connectionConfigType: // value for 'connectionConfigType'
 *      connectionConfigIds: // value for 'connectionConfigIds'
 *   },
 * });
 */
export function useEdiMessageTypesQuery(
  baseOptions?: Apollo.QueryHookOptions<IEdiMessageTypesQuery, IEdiMessageTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEdiMessageTypesQuery, IEdiMessageTypesQueryVariables>(
    EdiMessageTypesDocument,
    options
  )
}
export function useEdiMessageTypesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IEdiMessageTypesQuery, IEdiMessageTypesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IEdiMessageTypesQuery, IEdiMessageTypesQueryVariables>(
    EdiMessageTypesDocument,
    options
  )
}
export type EdiMessageTypesQueryHookResult = ReturnType<typeof useEdiMessageTypesQuery>
export type EdiMessageTypesLazyQueryHookResult = ReturnType<typeof useEdiMessageTypesLazyQuery>
export type EdiMessageTypesQueryResult = Apollo.QueryResult<
  IEdiMessageTypesQuery,
  IEdiMessageTypesQueryVariables
>
